// extracted by mini-css-extract-plugin
export default {"footer":"ju_SZaw9ODg6M6Y42MFi","link":"SwUbkS6l9XXnnsZazXL4","footerText":"Kg5d4vmensO6kWDErlow","title":"n1BvP53TlqAnIKf9gBZQ","copyright":"sHGsdJBt4SNoMuvZrYPw"};